import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import toast from "react-hot-toast";
import InputError from "../../../Components/InputError/InputError";
import { getType, toastStyle } from "../../../Helpers/Utils/Common";
import ApproveModal from "../../../Components/Modals/ApproveModal";
import { getAllBranches } from "../../../Helpers/apiCalls/branchApi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import upload from "../../../Assets/Images/upload.png";
import Upload from "antd/es/upload/Upload";
import FileExceedModal from "../../../Components/Modals/FileExceedModal";
import Modal from "antd/es/modal/Modal";
import trash from "../../../Assets/Images/trash.png";
import Select from "react-select";
import { validateAttendance, validateAttendanceUpload, validateTimeSheet } from "../../../Helpers/Validation/Employees/AttendanceValidation";
import { createAttendance, createMultipleAttendance, updateAttendance } from "../../../Helpers/apiCalls/Employees/AttendanceApi";
import * as XLSX from "xlsx";
import { getAttendance } from "../../../Helpers/apiCalls/Reports/DailyAttendanceApi";
import Footer from "../../../Components/Footer/Footer";
/*
    -- VIEW BUILT ITEM
*/
export default function AttendanceForm({add, edit}) {
    const { Dragger } = Upload;
    const { type, id } = useParams();
    let navigate = useNavigate();
    const accountType = getType();
    // const [isClicked, setIsClicked] = useState(false);
    const [items, setItems] = useState([]);
    const [branches, setBranches] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [prevAttachments, setPrevAttachments] = useState([]);
    const [showFileExceedModal, setShowFileExceedModal] = useState(false);
    const [preview, setPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState("");
    // BUILT ITEM INFO VARIABLES
    const [employees, setEmployees] = useState([]);
    const [addDetails, setAddDetails] = useState({
        branch_id: "",
        employee_id: "",
        datetime: "",
        overtime: "",
        time_sheet: [{actual_timein: "", actual_timeout: ""}],
    });
    const [branchId, setBranchId] = useState("")
    const [itemError, setItemError] = useState({})

    // Error Handling
    const [isError, setIsError] = useState({
        branch_from: false,
        qty: false,
        ingredients: false,
    });

    const [inactive, setInactive] = useState(true);

    async function fetchAttendance() {
        setAddDetails([]);
        const response = await getAttendance(id);

        if (response.data) {
            var data = response.data.data[0]
            data.time_sheet = data.attendance_entries.map((time) => {
                var info = time
                info.actual_timein = time?.actual_timein?.split(" ")[1]
                info.actual_timeout = time?.actual_timeout?.split(" ")[1]
                return info
            })
            setAddDetails(data);
            setPrevAttachments(response.data.data[0].attachments)
        }
    }

    // ATTENDANCE CHANGE HANDLER
    function handleTimeSheetChange(e, id) {
        const { name, value} = e.target;
        var newAddData = {...addDetails};
        var time_sheet = addDetails.time_sheet
        time_sheet[id][name] = value+":00";
        newAddData.time_sheet = time_sheet
        setAddDetails(newAddData);
    }

    const handleAddDetailsChange = (e) => {
        if (typeof e === "string") {
            setAddDetails((prevState) => ({
                ...prevState,
                ["item"]: e,
            }));
        } else if (e.target.name === "branch_from") {
            const { name, value } = e.target;
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        } else if (e.target.name === "build_item_id"){
            const { name, value } = e.target;
            const unit = getUnits(value);
            
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
                "unitList": unit[0],
                "build_item_unit": unit[0].item_units[0].unit_to,
                "build_item_unit_id": unit[0].item_units[0].id
            }));

        } else {
            const { name, value } = e.target;
            
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    function getUnits(id) {
        return items.filter((item) => item.id === id);
    }

    // SELECT DROPSEARCH CHANGE HANDLER
    function handleSelectChange(e) {
        const newList = {...addDetails};
        newList[e.name] = e.value;
        newList[e.select_value] = {
            label: e.label,
            value: e.value,
            name: e.name

        }
        setAddDetails(newList);
    }


    async function fetchBranches() {
        setBranches([]);
        const response = await getAllBranches();
        if (response.data) {
            var sortedBranches = response.data.data.sort((a, b) =>
                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
            );
            let branches = sortedBranches.map((a) => {
                return {
                value: a.id,
                label: a.name,
                name: "branch_id",
                select_value: "branch_id_value"
                };
            });
            setBranches(branches);
        }
    }

    async function fetchEmployees() {
        setEmployees([]);
        const response = await getAllEmployees();
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data
                info.name = "employee_id"
                info.select_value = "employee_id_value"
                info.label = data.first_name + " " + data.last_name
                info.value = data.id
                return info
            })
            setEmployees(data);
        }
    }
    
    function AddAttendaceBtn() {

        const newList = {...addDetails};
        var time_sheet = [...addDetails.time_sheet]
        time_sheet.push({ actual_timein: "", actual_timeout: ""})
        newList["time_sheet"] = time_sheet;
        setAddDetails(newList);

        // const newTimeSheet = { actual_timein: "", actual_timeout: ""};
        // setAddDetails((prevProduct) => [...prevProduct, newTimeSheet]);
    }

    useEffect(() => {
        if(edit) {
            fetchAttendance();
        }
        fetchBranches();
        fetchEmployees()
    }, []);


    const handleRemove = (selectedFile) => {
        var newlist = fileList.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFileList(newlist);
    };

    const handleBeforeUpload = (file) => {
        if (file.size > 2000000) {
            setShowFileExceedModal(true);
        } else if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls') && !file.name.endsWith('.numbers')) {
            toast.error('You can only upload XLSX files!');
            return false;
        } else {
            setFileList([file]);
            handleExtract(file)
        }
        return false;
    };

    
    const handleExtract = (file) =>{
        //convert file into an array of unsigned integers
        //file => variable that contains the file chosen
        file.arrayBuffer().then((res)=>{
    
            //get the filename without the extension
            let filename = file.name.substring(0, file.name.indexOf("."))
    
            //read data
            let data = new Uint8Array(res)
    
            //for creating the actual workbook from the data
            var workbook = XLSX.read(data, {type:"array"});
    
            //read the first sheet name in the excel file
            var sheetName = workbook.SheetNames[0];
    
            //locate the data inside the sheet name
            let worksheet = workbook.Sheets[sheetName]
    
            //convert sheet data to json data inside the certain sheet
            let jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1, defval: ''})
            let dates = jsonData.filter((data, key)=> key === 2 || key === 3)
            let timesheet_data = jsonData.filter((data, key)=>key !== 0 && key !== 1 && key !== 2 && key !== 3)
            // console.log(jsonData)
            // console.log("timesheet_data", timesheet_data)

            // to get the time frame and set the dates of the attendance
            // month year gets the month and year based on the file
            var month_year = dates[0][2].split(" ")[0].split("-").splice(0,2).join("-")
            // extracting the dates
            var attendance_date = dates[1].splice(0,15).map((data) => {
                var date = ""
                date = month_year + "-" + data
                return date
            })

            // Function to split the time string into time objects
            function createTimeObjects(timeArray) {
            const timeObjects = [];

                for (let i = 0; i < timeArray.length; i++) {
                    const timeString = timeArray[i];
                    // console.log(timeArray)

                    // Split the time string into individual time components
                    const times = timeString.match(/.{1,5}/g);

                    // Create an array of objects with the desired format
                    const arrayOfObjects = [];
                    for (let i = 0; i < times?.length; i += 2) {
                        const obj = {
                            actual_timein: times[i],
                            actual_timeout: times[i + 1]
                        };
                        arrayOfObjects.push(obj);
                    }
                    timeObjects.push(arrayOfObjects);
                }

                return timeObjects;
            }

            const time_sheets = []; // array that holds the attendance per employee per day
            const ids = []; // array that holds the ids of the employee
            let currentSheet = []; 
            let currentID = null;
            for (let i = 0; i < timesheet_data.length; i++) {
                const innerArray = timesheet_data[i].splice(0,15);
                if (innerArray.includes('ID:')) {
                    if (currentSheet.length > 0) {
                        time_sheets.push(currentSheet);
                        currentSheet = [];
                    }
                    currentID = innerArray[2]; // Extract the ID
                    if (currentID) {
                        ids.push(currentID);
                    }
                } else {
                    // 
                    const timeObjects = createTimeObjects(innerArray);  //split time and create timein and out objects
                    if (timeObjects.length > 0) {
                        currentSheet.push(timeObjects);
                    }
                }
            }

            if (currentSheet.length > 0) {
                time_sheets.push(currentSheet);
            }

            // console.log("IDs:", ids);
            // console.log("Time Sheets:", time_sheets);

            // setting everything alltogether
            var extracted_data = ids.map((employee, employee_index) => {
                var details = attendance_date.map((date, date_index) => {
                    var info = {
                        datetime: date + " 00:00:00",
                        employee_id: employee,
                        time_sheet: time_sheets[employee_index][0][date_index]
                    }
                    return info
                })
                return details
            })
            setAddDetails(extracted_data)
            
            if(timesheet_data.length === 0) {
                toast.error("Please upload and follow the correct excel format", {
                    style: toastStyle(),
                });
            }
        })
        
    }

    function handleRemoveItemAttachment(url) {
        
        var newList = prevAttachments.filter((data) => {return data.file_url !== url})
        setPrevAttachments(newList);
        setPreview(false)
    }

    // to delete time_sheet time in and out
    function handleRemoveTimeSheet(id) {
        const rowId = id;
        const newAddDetails = {...addDetails};
        var newTimeSheet = [...addDetails.time_sheet]
        newTimeSheet.splice(rowId, 1)
        newAddDetails.time_sheet = newTimeSheet;
        setAddDetails(newAddDetails);
    }


    function handleSave() {
        if(add) {
            type === "manual" ? handleSaveAttendance() : handleSaveMultipleAttendance()
        } else {
            handleUpdateAttendance()
        }
    }

    async function handleSaveAttendance() {
        var errors = validateTimeSheet(addDetails.time_sheet)
        setItemError(errors)
        if (validateAttendance(addDetails, setIsError) && Object.keys(errors).length === 0) {
            addDetails.attachments = fileList
            addDetails.status = "pending"
            const response = await createAttendance(addDetails);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/employeehours")
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        } else {
            toast.error(
                "Please fill in all required fields",
                { style: toastStyle() }
            );
        }
    }

    async function handleSaveMultipleAttendance() {
        if (validateAttendanceUpload(branchId, setIsError)) {
            const response = await createMultipleAttendance(addDetails, branchId, fileList);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/employeehours")
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        } else {
            toast.error(
                "Please fill in all required fields",
                { style: toastStyle() }
            );
        }
    }

    async function handleUpdateAttendance() {
        var errors = validateTimeSheet(addDetails.time_sheet)
        setItemError(errors)
        if (validateAttendance(addDetails, setIsError) && Object.keys(errors).length === 0) {
            addDetails.attachments = fileList
            addDetails.prev_files = prevAttachments
            const response = await updateAttendance(addDetails);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/employeehours")
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        } else {
            toast.error(
                "Please fill in all required fields",
                { style: toastStyle() }
            );
        }
    }

    
    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PAYROLL"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ADD TIMESHEET </h1>
                    </Col>
                </Row>
                
                <div className="mt-3 edit-form">
                    {
                        type === "manual" && (
                            <>
                            <Row className="nc-modal-custom-row ">
                                <Col sm={6} className="mb-2 mb-lg-0">
                                    Employee Name
                                    <label className="badge-required">{` *`}</label>
                                    <Select 
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select Employee..."
                                        value={addDetails.employee_id_value}
                                        options={employees}
                                        onChange={(e) => handleSelectChange(e)}
                                    />
                                    <InputError
                                        isValid={isError.employee_id}
                                        message={"Employee is required"}
                                    />
                                </Col>
                                <Col sm={6}>
                                    Branch
                                    <label className="badge-required">{` *`}</label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select Branch..."
                                        value={addDetails.branch_id_value}
                                        options={branches}
                                        onChange={(e) => handleSelectChange(e)}
                                    />
                                    <InputError
                                        isValid={isError.branch_id}
                                        message={"Branch is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row ">
                                <Col sm={4} className="mb-2 mb-lg-0">
                                    Date
                                    <label className="badge-required">{` *`}</label>
                                    <Form.Control
                                        type="datetime-local"
                                        name="datetime"
                                        value={addDetails.datetime}
                                        className="nc-modal-custom-input"
                                        onChange={(e) => handleAddDetailsChange(e)}
                                        required
                                    />
                                    <InputError
                                        isValid={isError.datetime}
                                        message={"Date is required"}
                                    />
                                </Col>
                                <Col sm={4} className="mb-2 mb-lg-0">
                                    Overtime
                                    <Form.Control
                                        type="text"
                                        name="overtime"
                                        value={addDetails.overtime}
                                        className="nc-modal-custom-input"
                                        onChange={(e) => handleAddDetailsChange(e)}
                                        required
                                    />
                                </Col>
                                <Col sm={4}>
                                    Overtime Remarks
                                    <Form.Control
                                        type="text"
                                        name="overtime_remarks"
                                        value={addDetails.overtime_remarks}
                                        className="nc-modal-custom-input"
                                        onChange={(e) => handleAddDetailsChange(e)}
                                        required
                                    />
                                </Col>
                            </Row>
                            {
                                addDetails?.time_sheet?.map((data, index) => {
                                    return (
                                        <Row className="nc-modal-custom-row ">
                                            <Col xs={6}>
                                                Time In
                                                <label className="badge-required">{` *`}</label>
                                                <Form.Control
                                                    type="time"
                                                    name="actual_timein"
                                                    defaultValue={data.actual_timein}
                                                    className="react-select-container"
                                                    onChange={(e) => handleTimeSheetChange(e, index)}
                                                />
                                                {itemError[index] && itemError[index].actual_timein && (
                                                    <div className="validity-error callout bottom">{itemError[index].actual_timein}</div>
                                                )}
                                            </Col>
                                            <Col xs={5}>
                                                Time Out
                                                <Form.Control
                                                    type="time"
                                                    name="actual_timeout"
                                                    defaultValue={data.actual_timeout}
                                                    className="react-select-container"
                                                    onChange={(e) => handleTimeSheetChange(e, index)}
                                                />
                                            </Col>
                                            <Col xs={1}>
                                                <div className="align-middle mt-3">
                                                    <img
                                                        src={trash}
                                                        alt="delete"
                                                        onClick={() =>
                                                            handleRemoveTimeSheet(index)
                                                        }
                                                        className="cursor-pointer mt-3"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                            <Row className="pt-3 PO-add-item">
                                <Col>
                                <Button type="button" onClick={() => AddAttendaceBtn()}>
                                    Add
                                </Button>
                                </Col>
                            </Row>
                            </>
                        )
                    }
                    {
                        type === "upload" && (
                            <>
                            <Row className="nc-modal-custom-row ">
                                <Col sm={6}>
                                    Branch
                                    <label className="badge-required">{` *`}</label>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select Branch..."
                                        // value={addDetails.branch_id_value}
                                        options={branches}
                                        onChange={(e) => setBranchId(e.value)}
                                    />
                                    <InputError
                                        isValid={isError.branch_id}
                                        message={"Branch is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <Dragger
                                        fileList={fileList}
                                        onRemove={handleRemove}
                                        beforeUpload={handleBeforeUpload}
                                        multiple={false}
                                        listType="picture"
                                        progress={{ showInfo: true }}
                                        // accept=".xlsx" // Accept only XLSX files
                                    >
                                        <img src={upload} className="cursor-pointer" />
                                        <p className="ant-upload-text">
                                            Click or drag file to this area to upload
                                        </p>
                                    </Dragger>
                                </Col>
                            </Row>
                            </>
                        )
                    }
                </div>
                <div className="d-flex justify-content-end pt-5 pb-3">
                    <button
                        type="button"
                        className="button-secondary me-3"
                        onClick={() => navigate("/employeehours")}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="button-primary me-3"
                        onClick={() => handleSave()}
                    >
                        Save
                    </button>
                </div>
            </div>
            <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
                <Row className="justify-content-center">
                    <img
                        alt="example"
                        style={{
                        width: '100%',
                        }}
                        src={previewFile}
                    />
                    <div className="mt-2 d-flex justify-content-center">
                        <img
                            src={trash}
                            alt="trash"
                            onClick={() => handleRemoveItemAttachment(previewFile)}
                            className="cursor-pointer"
                        />
                    </div>
                </Row>
            </Modal>
            <FileExceedModal
                show={showFileExceedModal}
                onHide={() => setShowFileExceedModal(false)}
                size="2MB"
            />
            <Footer/>
        </div>
    );
}
